export default "__VITE_ASSET__08f89427__"